import { useAuthStore } from '@/stores/authStore';
import { canAccessSniper, type Role } from '@/types/navigation';

/**
 * Whether the current user may open the per-game Sniper screen
 * (/sniper/:gameKey) and see the dashboard target icon: admin, or a trader
 * with the resolved fail-closed grant (GET /api/trader/me → `sniperAccess`,
 * from traderRules.sniperEnabled). No manager role pass — sniper arms
 * real-money runners. Display gating only; the relay re-checks
 * admin-or-grant on every /api/sniper request.
 */
export function useSniperAccess(): boolean {
  const role = (useAuthStore((s) => s.user?.role) ?? 'trader') as Role;
  const sniperAccess = useAuthStore((s) => s.user?.sniperAccess ?? false);
  return canAccessSniper(role, sniperAccess);
}
